import { createFileRoute } from "@tanstack/react-router"
import Profile from "@/components/account/profile"

export const Route = createFileRoute("/_authed/account/profile")({
  component: RouteComponent,
})

export default function RouteComponent() {
  return <Profile />
}
